module.exports = __webpack_public_path__ + "static/map-062b76b917f29fd53a7e9a7457c6254c.png";